export default () => ({
  masters: [],
  formInput: null,
})
